import { useState } from "react";
import { apiLogin } from "../data/api";

import type { ApiUser } from "../data/api";

import "./DrawingsDashboard.scss";

interface AuthDialogProps {
  onAuth: (user: ApiUser) => void;
  onSkip: () => void;
}

export const AuthDialog = ({ onAuth, onSkip }: AuthDialogProps) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const { user } = await apiLogin(email, password);
      onAuth(user);
    } catch (err: any) {
      setError(err.message || "Erro ao autenticar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="drawings-overlay">
      <div className="auth-dialog">
        <h2>Entrar</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="auth-input"
          />
          <input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            className="auth-input"
          />

          {error && <div className="auth-error">{error}</div>}

          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? "Carregando..." : "Entrar"}
          </button>
        </form>

        <button className="auth-skip" onClick={onSkip}>
          Continuar sem conta (somente local)
        </button>
      </div>
    </div>
  );
};
